<template>
  <v-card class="pa-6">
    <BaseDataTable
      :headers="headers"
      :items="empresasFilial"
      :items-per-page="8"
      :loading="loading"
      :paginate="true"
      :lastPage="lastPage"
      :currentPage="currentPage"
      @pageChange="fetchBlocks({ ...filter, page: $event })"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="8" lg="8" class="pa-0"> </v-col>
          <v-col cols="12" md="4" lg="4" class="pa-0">
            <MenuFilterSearchTable
              :placeholder="'Buscar por nome ou cnpj da empresa'"
              :textQuery="'nome'"
              :codQuery="'cnpj'"
              @textValue="updateFilter($event)"
            />
          </v-col>
        </v-row>
      </template>

      <!-- ---------------- header ---------------- -->
      <template v-slot:header.schema="{ header }">
        <span>
          {{ header.text }}
          <MenuFilterSelect
            :items="[
              { shema: 'NBS', descricao: 'NBS' },
              { shema: 'CCV', descricao: 'CCV' },
            ]"
            :itemText="'descricao'"
            :itemValue="'shema'"
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template>

      <template v-slot:header.cod_ibge="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template>

      <template v-slot:header.descricao="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template>

      <template v-slot:header.uf="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            localFilter="api"
            :label="header.text"
            :query="header.value"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          />
        </span>
      </template>
      <!-- ---------------- items ---------------- -->
      <template v-slot:item.processa_rpa_pecas="{ item }">
        <div class="bg-error d-flex align-center">
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                :disabled="item.status"
                class="mx-1 cursor-pointer"
                :color="!item.status ? 'primary' : 'default'"
                size="25"
              >
                mdi-lock-open-variant-outline
              </v-icon>
            </template>
            <span> Desbloqueado</span>
          </v-tooltip> -->
          <div class="d-flex align-center">
            <v-switch
              v-can:permission="'empresa-filial#update'"
              color="primary"
              v-model="item.status"
              @click.native.stop="changeBlock(item)"
            />

            <p class="font-weight-bold pa-0 ma-0 ml-1">
              {{ item.processa_rpa_pecas == "S" ? "Sim" : "Não" }}
            </p>
          </div>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                class="mx-1 cursor-pointer"
                :disabled="!item.status"
                :color="item.status ? 'primary' : 'default'"
                size="25"
              >
                mdi-lock-outline
              </v-icon>
            </template>
            <span> Bloqueado</span>
          </v-tooltip> -->
        </div>
      </template>
      <template v-slot:item.logs="{ item }">
        <v-btn color="#4ebf53" icon @click="openModal(item)">
          <v-icon>mdi-file-document</v-icon>
        </v-btn>
      </template>
    </BaseDataTable>

    <ModalLogs
      :dialog="dialog"
      :chaveEmpresa="chaveEmpresa"
      @close="dialog = false"
    />
  </v-card>
</template>

<script>
import EmpresaFilial from "@/services/http/rpa/EmpresaFilial";

import BaseDataTable from "@/components/BaseDataTable.vue";
import MenuFilter from "@/components/MenuFilter.vue";
import MenuFilterSearchTable from "@/components/MenuFilterSearchTable.vue";
import MenuFilterSelect from "@/components/MenuFilterSelect.vue";
import ModalLogs from "./ModalLogs.vue";

export default {
  components: {
    MenuFilter,
    MenuFilterSearchTable,
    MenuFilterSelect,
    BaseDataTable,
    ModalLogs,
  },

  data() {
    return {
      lastPage: 1,
      currentPage: 1,
      loading: false,
      empresasFilial: [],

      idPrefeitura: "",
      dialog: false,
      chaveEmpresa: "",
      filter: {},
      status: { S: true, N: false },
      statusToProcessaVersor: { false: "S", true: "N" },
      headers: [
        {
          text: "Apelido",
          value: "apelido",
          align: "center",
        },
        {
          text: "Nome",
          value: "nome",
        },
        {
          text: "CNPJ",
          value: "cnpj",
        },
        {
          text: "Processar peças",
          value: "processa_rpa_pecas",
          align: "center",
        },

        {
          text: "Logs",
          value: "logs",
          align: "center",
        },
      ],
    };
  },
  watch: {
    filter(value) {
      this.fetchBlocks(value);
    },
  },
  methods: {
    updateFilter(event) {
      this.filter = { ...this.filter, ...event };
    },
    openModal(item) {
      this.chaveEmpresa = item.chave_empresa;
      this.dialog = true;
    },
    async fetchBlocks(filters) {
      try {
        this.loading = true;
        let { data } = await EmpresaFilial().show({
          ...filters,
          per_page: 8,
        });
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;

        this.empresasFilial = data.data.map((item) => {
          return { ...item, status: this.status[item.processa_rpa_pecas] };
        });

        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async changeBlock(item) {
      item.status = !item.status;

      try {
        let text = item.processa_rpa_pecas == "N" ? "Ativar" : "Desativar";

        await this.$swal({
          title: `${text} lançamento de Peças`,
          text: `Deseja ${text.toLowerCase()} lançamento de peças para esta Filial?`,
          icon: "question",
          showDenyButton: true,
          confirmButtonText: `Sim! ${text.toLowerCase() || ""}`,
          denyButtonText: "Não, Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const resp = await EmpresaFilial(item.chave_empresa).update({
              processa_rpa_pecas: this.statusToProcessaVersor[item.status],
            });

            item.status = this.status[resp.data.processa_rpa_pecas];
            item.processa_rpa_pecas = resp.data.processa_rpa_pecas;
            return;
          }
          item.status = this.status[item.processa_rpa_pecas];
        });
      } catch (error) {
        item.status = this.status[item.processa_rpa_pecas];
        console.log(error);
      }
    },
  },

  created() {
    this.fetchBlocks();
  },
};
</script>

<style scoped>
.bg-error {
  /* background-color: red !important; */
  display: flex;
  justify-content: center;
}
.cursor-pointer {
  cursor: info;
}
</style>
